import React from 'react';
import { Page } from '../Page';
import { Shield, Heart, Bone } from 'lucide-react';
export function SupplementMultiVitamin() {
  return <Page pageNumber={14} variant="light" data-id="element-2534">
      <div className="flex flex-col h-full" data-id="element-2535">
        <div className="mb-6 pt-4" data-id="element-2536">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-2537">
            Supplement Spotlight
          </p>
          <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-2538">
            Daily Multi-Vitamin
          </h1>
          <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-2539">
            Fill the nutrient gaps that come with eating less
          </p>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-2540" />
        </div>

        <div className="mb-8" data-id="element-2541">
          <h2 className="text-sm font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-2542">
            Why It Matters on GLP-1
          </h2>
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-2543">
            GLP-1 medications reduce appetite and caloric intake, which
            increases the risk of micronutrient gaps. A comprehensive multi
            fills those gaps as "dietary insurance," especially important when
            eating less food overall. Thorne's multis use highly bioavailable
            forms without unnecessary additives, maximizing absorption even with
            smaller meals.
          </p>
        </div>

        {/* 3 Bottles Row */}
        <div className="grid grid-cols-3 gap-6 mb-8" data-id="element-2544">
          <div className="flex flex-col items-center" data-id="element-2545">
            <img src="https://cdn.magicpatterns.com/uploads/cVkBKeTkhs1FfSNaZuZQaq/pasted-image.png" alt="Basic Nutrients 2/Day" className="h-40 object-contain mb-4" data-id="element-2546" />
            <h3 className="text-sm font-bold text-[#1F1F1F] text-center mb-1" data-id="element-2547">
              Basic Nutrients 2/Day
            </h3>
            <p className="text-[10px] text-[#7A7A70] text-center uppercase tracking-wider" data-id="element-2548">
              All Adults
            </p>
          </div>
          <div className="flex flex-col items-center" data-id="element-2549">
            <img src="https://cdn.magicpatterns.com/uploads/oATeeYw3b3m4kzEqAuzdQa/pasted-image.png" alt="Men's Multi 50+" className="h-40 object-contain mb-4" data-id="element-2550" />
            <h3 className="text-sm font-bold text-[#1F1F1F] text-center mb-1" data-id="element-2551">
              Men's Multi 50+
            </h3>
            <p className="text-[10px] text-[#7A7A70] text-center uppercase tracking-wider" data-id="element-2552">
              Men 50+
            </p>
          </div>
          <div className="flex flex-col items-center" data-id="element-2553">
            <img src="https://cdn.magicpatterns.com/uploads/9fk743VWayU2KFEujmpVDA/pasted-image.png" alt="Women's Multi 50+" className="h-40 object-contain mb-4" data-id="element-2554" />
            <h3 className="text-sm font-bold text-[#1F1F1F] text-center mb-1" data-id="element-2555">
              Women's Multi 50+
            </h3>
            <p className="text-[10px] text-[#7A7A70] text-center uppercase tracking-wider" data-id="element-2556">
              Women 50+
            </p>
          </div>
        </div>

        {/* Comparison Cards */}
        <div className="grid grid-cols-3 gap-4 mb-6" data-id="element-2557">
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 flex flex-col" data-id="element-2558">
            <Shield className="w-5 h-5 text-tealslate mb-3" data-id="element-2559" />
            <p className="text-xs text-[#3B3B3B] leading-[1.6] mb-4 flex-1" data-id="element-2560">
              Simplified daily coverage. Includes chromium for blood sugar
              support and highly absorbable zinc bisglycinate.
            </p>
            <div className="border-t border-[#D8D8D0] pt-3 mt-auto" data-id="element-2561">
              <p className="text-[11px] font-bold text-[#1F1F1F]" data-id="element-2562">2 caps/day</p>
              <p className="text-[10px] text-[#7A7A70]" data-id="element-2563">60 caps per bottle</p>
            </div>
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 flex flex-col" data-id="element-2564">
            <Heart className="w-5 h-5 text-tealslate mb-3" data-id="element-2565" />
            <p className="text-xs text-[#3B3B3B] leading-[1.6] mb-4 flex-1" data-id="element-2566">
              Prostate and heart focus. Includes lycopene and zinc for prostate
              health, plus magnesium for muscle support.
            </p>
            <div className="border-t border-[#D8D8D0] pt-3 mt-auto" data-id="element-2567">
              <p className="text-[11px] font-bold text-[#1F1F1F]" data-id="element-2568">6 caps/day</p>
              <p className="text-[10px] text-[#7A7A70]" data-id="element-2569">180 caps per bottle</p>
            </div>
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 flex flex-col" data-id="element-2570">
            <Bone className="w-5 h-5 text-tealslate mb-3" data-id="element-2571" />
            <p className="text-xs text-[#3B3B3B] leading-[1.6] mb-4 flex-1" data-id="element-2572">
              Bone support focus. Includes Vitamins D3 and K2. Iron-free formula
              designed for postmenopausal women.
            </p>
            <div className="border-t border-[#D8D8D0] pt-3 mt-auto" data-id="element-2573">
              <p className="text-[11px] font-bold text-[#1F1F1F]" data-id="element-2574">6 caps/day</p>
              <p className="text-[10px] text-[#7A7A70]" data-id="element-2575">180 caps per bottle</p>
            </div>
          </div>
        </div>

        <div className="mt-auto flex items-center gap-3" data-id="element-2576">
          <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-2577" />
          <div data-id="element-2578">
            <p className="text-xs font-bold text-[#1F1F1F]" data-id="element-2579">Choose Your Fit</p>
            <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-2580">
              If you're interested in a supplement plan tailored to you, check
              out the link below! Fullscript provides third-party tested, safe
              and effective supplements to help get your health where you want
              it at wholesale prices.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}